import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

export const CATEGORY_LINKS = [
  { slug: 'pendants', label: 'Pendants' },
  { slug: 'ceiling-lights', label: 'Ceiling lights' },
  { slug: 'chandeliers', label: 'Chandeliers' },
  { slug: 'wall-lights', label: 'Wall lights' },
  { slug: 'table-lamps', label: 'Table lamps' },
  { slug: 'floor-lamps', label: 'Floor lamps' },
];

const linkCls = ({ isActive }) =>
  `whitespace-nowrap px-3 py-2 text-sm transition-colors border-b-2 ${
    isActive ? 'border-gray-900 text-gray-900 font-medium' : 'border-transparent text-gray-500 hover:text-gray-900'
  }`;

export const CatalogueNav = ({ brandId, brandName, initialQuery = '' }) => {
  const [q, setQ] = useState(initialQuery);
  const navigate = useNavigate();
  const base = `/brand/${brandId}`;

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`${base}/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div className="relative md:sticky md:top-20 z-30 bg-white/95 backdrop-blur-sm border-b border-gray-100" data-testid="catalogue-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-center gap-2 md:gap-6 py-2">
        <Link to={base} className="text-xs uppercase tracking-widest text-gray-400 hover:text-gray-900 shrink-0" data-testid="catalogue-nav-brand">
          {brandName}
        </Link>
        <nav className="flex overflow-x-auto -mx-1 flex-1 scrollbar-none">
          <NavLink end to={`${base}/lighting`} className={linkCls} data-testid="catalogue-nav-lighting">Lighting</NavLink>
          {CATEGORY_LINKS.map((c) => (
            <NavLink key={c.slug} to={`${base}/lighting/${c.slug}`} className={linkCls} data-testid={`catalogue-nav-${c.slug}`}>
              {c.label}
            </NavLink>
          ))}
          <NavLink to={`${base}/families`} className={linkCls} data-testid="catalogue-nav-families">Families</NavLink>
        </nav>
        <form onSubmit={submit} className="relative shrink-0" data-testid="catalogue-search-form">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search e.g. KLYFTA, pendant, brass"
            className="text-sm border border-gray-200 rounded-md pl-9 pr-3 py-2 w-full md:w-72 focus:outline-none focus:ring-1 focus:ring-gray-400"
            data-testid="catalogue-search-input"
          />
        </form>
      </div>
    </div>
  );
};
